import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import Debugger from './../debugger/Debugger';
import {
  dpiResolution,
  toggleDpiOverlays,
} from '../../redux/actions/entities/placeholders';
import {
  getBookSizes,
  getOriginalWidth,
  CM_TO_INCH,
  INCH_IN_PX,
} from '../../redux/helpers/';
import { imageChange } from '../../redux/actions/ui/imageChange';
import './Texture.css';


const TextureTarget = {
  canDrop() {
    return true;
  },

  drop() {

  },
};

function collect(connected, monitor) {
  return {
    connectDropTarget: connected.dropTarget(),
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true }),
    canDrop: true,
    itemType: monitor.getItemType(),
  };
}

class Texture extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
    this.setTimeout = null;
  }

  componentWillUpdate(nextProps) {
    const {
      pageId, pages, texture,
    } = nextProps;
    const { isCover, isActive } = pages[pageId];

    if (isActive && isCover && Object.values(nextProps.droppedImages).length === 1) {
      const coverImages = Object.values((pages[pageId].droppedImages)).length;
      const placeholderSize = Object.values((pages[pageId].placeholders)).length;
      if (coverImages === placeholderSize && !texture.isChanged) {
        this.props.dispatch(imageChange(false));
      }
    }

    const bookSizes = {
      width: Math.round(((getBookSizes().pageWidth / 10) * CM_TO_INCH) * INCH_IN_PX),
    };

    if (this.props.texture.transformations.scaleX !== nextProps.texture.transformations.scaleX) {
      const {
        width, id, imageObject,
      } = nextProps.texture;
      let isReachMinimum = false;
      if (!imageObject) {
        return false;
      }
      const zoomLevel = this.props.texture.transformations.scaleX;
      const bookRatio = bookSizes.width / getOriginalWidth(this.props.bookProperties.bookSizes);
      if ((width * bookRatio) / 3 > imageObject.originalWidth / zoomLevel) {
        isReachMinimum = true;
      }

      if (isReachMinimum) {
        const { DPI } = nextProps.texture;
        if (!DPI.isSmall && !DPI.isClicked) {
          this.props.dispatch(dpiResolution(id, true));
        }
      }
    }
  }

  setDebounce = () => {
    this.setTimeout = clearTimeout(this.setTimeout);
    this.setTimeout = setTimeout(this.stopRendering, 5800);
  }


  removeOverlay = () => {
    this.props.dispatch(toggleDpiOverlays(true));
  }

  renderButton() {
    const {
      DPI, imageRatio,
    } = this.props.texture;

    const { imageObject } = this.props.texture;

    if (!imageObject) {
      return;
    }
    let isReachMinimum = false;

    if (imageRatio > 3) {
      isReachMinimum = true;
    }

    if (isReachMinimum && !DPI.isClicked) {
      return <button className="dpi-button" onClick={this.removeOverlay}>Ok</button>;
    }
  }

  renderCanvas = () => {
    const {
      width,
      height,
      imageObject: { mediumThumbnail } = { mediumThumbnail: '' },
      imageObject: { originalWidth } = { originalWidth: '' },
      imageObject: { originalHeight } = { originalHeight: '' },
      imageObject: { mediumThumbnailPath } = { mediumThumbnailPath: '' },
      imageObject: { fileName } = { fileName: '' },
      id,
      isChanged,
      transformations,
      DPI,
      imageRatio,
    } = this.props.texture;

    const {
      index,
      ratio,
      onMouseDown,
      onMouseMove,
      onMouseUp,
      onClick,
      DPIResolution,
      isPreview,
      bookProperties,
    } = this.props;

    return (
      <div className="canvas-wrapper">
        <Debugger
          placeholderId={id}
          image={`${mediumThumbnailPath || ''}${fileName || ''}`}
          zoom={transformations.scaleX}
          rotate={transformations.rotate}
          placeholderWidth={width}
          placeholderHeight={height}
          fillWidth={transformations.fillSizes.width}
          fillHeight={transformations.fillSizes.height}
          autofill={bookProperties.autofill}
          originalImageWidth={originalWidth}
          originalImageHeight={originalHeight}
          X={transformations.moveX}
          Y={transformations.moveY}
        />
        <canvas
          ref={`canvas-${index}`}
          data-image-url={mediumThumbnail || ''}
          data-imageWidth={originalWidth || ''}
          data-DPI={isPreview ? '' : DPIResolution}
          data-isClicked={isPreview ? '' : DPI.isClicked}
          data-imageRatio={imageRatio}
          data-placeholderId={id}
          key={index}
          data-index={index}
          data-scale={transformations.scaleX}
          width={Math.round(width * ratio)}
          data-isChanged={isChanged}
          height={Math.round(height * ratio)}
          className={`canvas-${index}`}
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          onClick={onClick}
        />

        {isPreview ? '' : this.renderButton()}
      </div>
    );
  }

  render() {
    const {
      connectDropTarget,
    } = this.props;

    return connectDropTarget(this.renderCanvas());
  }
}

Texture.defaultProps = {
  index: 0,
  texture: {},
  ratio: 0,
  onMouseDown: () => {},
  onMouseMove: () => {},
  onMouseUp: () => {},
  onClick: () => {},
  DPIResolution: false,
  bookProperties: {},
};

Texture.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  index: PropTypes.number,
  texture: PropTypes.object,
  ratio: PropTypes.number,
  onMouseDown: PropTypes.func,
  onMouseMove: PropTypes.func,
  onMouseUp: PropTypes.func,
  onClick: PropTypes.func,
  DPIResolution: PropTypes.bool,
  bookProperties: PropTypes.object,
};

Texture = DropTarget(['Image', 'SwapImageIcon'], TextureTarget, collect)(Texture);
export default connect(state => ({
  bookProperties: state.bookProperties,
  pages: state.entities.pages.byId,
  backgroundType: state.editorUI.bookProperties.backgroundType,
}))(Texture);



// WEBPACK FOOTER //
// ./src/components/texture/Texture.jsx